import React from 'react'
import PropTypes from 'prop-types'
import { Title42, Title100 } from 'components/Typography'
import { ListicleHeadline } from './Listicle.style'

const Listicle = ({ number, headline }) => {
  return (
    <>
      {(number || headline) && (
        <ListicleHeadline>
          <Title100 style={{ opacity: '0.3' }}>{number}</Title100>
          <Title42 as="h4">{headline}</Title42>
        </ListicleHeadline>
      )}
    </>
  )
}

Listicle.propTypes = {
  number: PropTypes.string,
  headline: PropTypes.string,
}

Listicle.defaultProps = {
  headline: '',
  number: '',
}

export default Listicle
